import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { QrCode, SplitSquareHorizontal, Check } from "lucide-react";

const METHODS = [
  { id: "qr", label: "QR", icon: QrCode },
  { id: "split", label: "Split", icon: SplitSquareHorizontal },
];

export const PaymentPreview = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setActive((a) => (a + 1) % METHODS.length), 2600);
    return () => clearInterval(t);
  }, []);

  const Method = METHODS[active];

  return (
    <div
      data-testid="payment-preview"
      className="relative rounded-2xl border border-border bg-card p-5 shadow-2xl shadow-black/5 sm:p-6"
    >
      <div className="flex items-center justify-between">
        <span className="eyebrow text-muted-foreground">MONOE Terminal</span>
        <span className="flex items-center gap-1.5 font-mono-ui text-[10px] text-muted-foreground">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> LIVE PREVIEW
        </span>
      </div>

      <div className="mt-5 grid h-44 place-items-center rounded-xl border border-border bg-secondary">
        <AnimatePresence mode="wait">
          <motion.div
            key={Method.id}
            initial={{ opacity: 0, y: 8, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -8, scale: 0.96 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col items-center gap-3"
          >
            <div className="grid h-16 w-16 place-items-center rounded-2xl bg-foreground text-background">
              <Method.icon className="h-8 w-8" />
            </div>
            <span className="font-display text-sm font-semibold">{Method.label} Payment</span>
          </motion.div>
        </AnimatePresence>
      </div>

      <div className="mt-4 grid grid-cols-2 gap-2">
        {METHODS.map((m, i) => (
          <button
            key={m.id}
            type="button"
            data-testid={`payment-method-${m.id}`}
            onClick={() => setActive(i)}
            className={`flex flex-col items-center gap-1 rounded-lg border px-2 py-2 transition-colors ${
              i === active ? "border-foreground bg-foreground text-background" : "border-border text-muted-foreground"
            }`}
          >
            <m.icon className="h-4 w-4" />
            <span className="text-[10px] font-medium">{m.label}</span>
          </button>
        ))}
      </div>

      <div className="mt-4 flex items-center justify-between rounded-lg border border-border px-4 py-3">
        <div>
          <p className="text-[10px] uppercase tracking-wide text-muted-foreground">Settles to merchant</p>
          <p className="font-mono-ui text-sm font-semibold">$42.00</p>
        </div>
        <span className="flex items-center gap-1 rounded-full bg-emerald-500/10 px-2.5 py-1 text-[11px] font-medium text-emerald-600 dark:text-emerald-400">
          <Check className="h-3 w-3" /> Confirmed
        </span>
      </div>
    </div>
  );
};
